// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8738723f","472":"342f3847","592":"6d7de513","648":"120a5055","952":"bebe2b75"}[chunkId] + ".chunk.js";
};